import { render, staticRenderFns } from "./HongQianHomePage.vue?vue&type=template&id=aa036a50&scoped=true"
import script from "./HongQianHomePage.vue?vue&type=script&lang=js"
export * from "./HongQianHomePage.vue?vue&type=script&lang=js"
import style0 from "./HongQianHomePage.vue?vue&type=style&index=0&id=aa036a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa036a50",
  null
  
)

export default component.exports